import { render, staticRenderFns } from "./upload-image.vue?vue&type=template&id=6486a637&scoped=true"
import script from "./upload-image.vue?vue&type=script&lang=js"
export * from "./upload-image.vue?vue&type=script&lang=js"
import style0 from "./upload-image.vue?vue&type=style&index=0&id=6486a637&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6486a637",
  null
  
)

export default component.exports